import React from 'react';
import { Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';


const CustomTooltipComponent = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
    '& .MuiTooltip-tooltip': {
      backgroundColor: '#4f46e5',
      color: '#FFFFFF',
      fontSize: '0.8rem',
      fontWeight: 'bold',
    },
    '& .MuiTooltip-arrow': {
      color: '#4f46e5',
    },
});

export default CustomTooltipComponent;